export interface RouteDetails {
  name: string;
  path: string;
}

export type RoutesSection<T extends string> = {
  [key in T]: RouteDetails;
};

export type EnrollmentKeys =
  | 'profileEdit'
  | 'benefits'
  | 'financialPlans'
  | 'plans'
  | 'comparePlans'
  | 'profile'
  | 'questionnaire'
  | 'survey'
  | 'communicationPreferences'
  | 'family'
  | 'volume'
  | 'benefitDetails'
  | 'eSign'
  | 'manageBeneficiaries'
  | 'manageProviders'
  | 'benefitsInfo'
  | 'benefitInfo'
  | 'review'
  | 'beforeStarted'
  | 'oliveAdvisor'
  | 'plugin'
  | 'decisionSupportRouter'
  | 'AdditionalPlanInfo';

interface Routes {
  enrollment: RoutesSection<EnrollmentKeys>;
}

export const ROUTES: Routes = {
  enrollment: {
    profile: {
      name: 'navigation.enrollment:profile',
      path: '/profile',
    },
    family: {
      name: 'navigation.enrollment:family',
      path: '/family',
    },
    benefits: {
      name: 'navigation.enrollment:benefits',
      path: '/benefits',
    },
    financialPlans: {
      name: 'navigation.enrollment:financial',
      path: '/financial/plans',
    },
    plans: {
      name: 'navigation.enrollment:plans',
      path: '/plans',
    },
    comparePlans: {
      name: 'navigation.enrollment:comparePlans',
      path: '/plans/compare-plans',
    },
    communicationPreferences: {
      name: 'navigation.enrollment:communication-preferences',
      path: '/communication-preferences',
    },
    questionnaire: {
      name: 'navigation.enrollment:questionnaire',
      path: '/questionnaire',
    },
    survey: {
      name: 'navigation.enrollment:survey',
      path: '/survey',
    },
    profileEdit: {
      name: 'navigation.enrollment:profileEdit',
      path: '/profile/edit',
    },
    benefitsInfo: {
      name: 'navigation.enrollment:benefits-info',
      path: '/benefits-info',
    },
    benefitInfo: {
      name: 'navigation.enrollment:benefit-info',
      path: '/benefit-info',
    },
    volume: {
      name: 'navigation.enrollment:volume',
      path: '/volume',
    },
    benefitDetails: {
      name: 'navigation.enrollment:benefit-details',
      path: '/benefit-details',
    },
    eSign: {
      name: 'navigation.enrollment:eSign',
      path: '/esign',
    },
    AdditionalPlanInfo: {
      name: 'navigation.enrollment:AdditionalPlanInfo',
      path: '/AdditionalPlanInfo',
    },
    manageBeneficiaries: {
      name: 'navigation.enrollment:manage-beneficiaries',
      path: '/manage-beneficiaries',
    },
    manageProviders: {
      name: 'navigation.enrollment:manage-providers',
      path: '/manage-providers',
    },
    review: {
      name: 'navigation.enrollment:review',
      path: '/review',
    },
    beforeStarted: {
      name: 'navigation.enrollment:before-started',
      path: '/before-started',
    },
    oliveAdvisor: {
      name: 'navigation.enrollment:olive-advisor',
      path: '/olive-advisor',
    },
    plugin: {
      name: 'navigation.enrollment:plugin',
      path: '/plugin',
    },
    decisionSupportRouter: {
      name: 'navigation.enrollment:decisionSupportRouter',
      path: '/benefits-decision-support',
    },
  },
};
